module.exports = __webpack_public_path__ + "static/media/Ralph Nader - 2000.9e519d8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Ralph Nader - 2000.jpg
// module id = 535
// module chunks = 0